function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
var buildStyle = function() {
    var maxWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 282;
    return function(param, param1) {
        var _backgroundColor = param.backgroundColor, font = param.font, size = param.size, spacing = param.spacing, experimentalBlocks = param.experimentalBlocks, readingDirection = param1.readingDirection;
        var ref;
        var backgroundColor = (ref = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.backgroundColor) !== null && ref !== void 0 ? ref : _backgroundColor;
        var _color;
        var fontColor = (_color = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.font.color) !== null && _color !== void 0 ? _color : font.color;
        return {
            caret: {
                base: {
                    borderColor: backgroundColor.neutral.fill.surface
                }
            },
            tooltipWrapper: {
                base: _objectSpread({
                    backgroundColor: backgroundColor.neutral.fill.surface,
                    borderRadius: size.border.radius.threeX,
                    color: fontColor.fill,
                    fontFamily: font.base.family,
                    fontSize: font.base.size.xxs,
                    fontWeight: font.base.weight.regular,
                    maxWidth: maxWidth,
                    padding: spacing[3],
                    pointerEvents: 'none'
                }, readingDirection)
            }
        };
    };
};
var useStyle = function(isRtl, maxWidth) {
    var builtStyle = useBuildStyleWithTheme(buildStyle(maxWidth), {
        isRtl: isRtl
    });
    var ref = builtStyle !== null && builtStyle !== void 0 ? builtStyle : {}, caret = ref.caret, tooltipWrapper = ref.tooltipWrapper;
    return useMemo(function() {
        return {
            caret: caret === null || caret === void 0 ? void 0 : caret.base,
            tooltipWrapper: tooltipWrapper === null || tooltipWrapper === void 0 ? void 0 : tooltipWrapper.base
        };
    }, [
        caret === null || caret === void 0 ? void 0 : caret.base,
        tooltipWrapper === null || tooltipWrapper === void 0 ? void 0 : tooltipWrapper.base
    ]);
};
export default useStyle;
